import '../common/BackLayout/BackLayout.css';
import './BrochureContainer.css';
import '../common/FrontLayout/FrontLayout.css';

import * as React from 'react';
import { connect } from 'react-redux';

import { IPlaceHolder, IDocument, IPage, ISpread, IUserData, IEditorState, IDragInfo } from '../../../../../infrastructure/interfaces';
import { IWizardState } from '../../../../Wizard/Wizard';
import { PageType } from '../../../../../infrastructure/PageType';
import BackLayout from '../common/BackLayout';
import FrontLayout from '../common/FrontLayout';
import PageLayout from './Components/PageLayout';
export interface IBrochureProps {
  wizard?: IWizardState;
  document: IDocument | null;
  userData?: IUserData;
  editor?: IEditorState;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  moveCrop?(dragIndex: number, hoverIndex: number): void;
}
export interface IBrochureState {
  wizard: IWizardState;
  document: IDocument | null;
  userData: IUserData;
  editor: IEditorState;
}
const mapStateToProps = (state: any): any => {
  return {
    wizard: state.wizard,
    document: state.document,
    userData: state.user.data,
    editor: state.editor,
  };
};
const mapDispatchToProps = (dispatch: any): any => {
  return {

  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class BrochureContainer extends React.Component<IBrochureProps, IBrochureState> {

  renderPage(page: IPage, second: boolean) {
    return (
      <PageLayout
        page={page}
        second={second}
        removeProduct={this.props.removeProduct.bind(this)}
        handleDrop={this.props.handleDrop}
        document={this.props.document}
      />
    );
  }

  renderFront = () => {
    const {
      document,
      moveCrop,
    } = this.props;

    return (
      <FrontLayout
        document={document}
        moveCrop={moveCrop}
        isSpreadView={true}
        isEditorRendering={true}
        isWebPageCover={true}
        mainView={true}
      />
    );
  }

  renderBack = () => {
    return (
      <BackLayout
        document={this.props.document}
        brandings={this.props.document!.brandings}
        isEditorRendering={true}
        isWebPageCover={true}
        disclaimers={this.props.wizard!.disclaimers}
      />
    );
  }

  renderSpread(spread: ISpread) {
    if (spread === null) {
      return (
        <div className="brochure-product-page-wrapper"></div>
      );
    }

    if (spread.right) {
      if (spread.left.type === PageType.Page && spread.right.type === PageType.Page) {
        return (
          <div className="brochure-product-page-wrapper">
            <div className={`crop-cont`}>
              {this.renderPage(spread.left, false)}
              {this.renderPage(spread.right, true)}
            </div>
          </div>
        );
      }
    } else {
      if (spread.left.type === PageType.Page) {
        return (
          <div className="brochure-product-page-wrapper">
            <div className={`crop-cont`}>
              {this.renderPage(spread.left, false)}
            </div>
          </div>
        );
      }
    }
    if (spread.left.type === PageType.Back && ((spread.right != null) && (spread.right.type === PageType.Front))) {
      return (
        <div className={`crop-cont crop-cont--cover`}>
          {this.renderBack()}
          {this.renderFront()}
        </div>
      );
    }
    return (
      <div className="brochure-product-page-wrapper"></div>
    );
  }
  renderSingle(selectedPage: IPage) {
    switch (selectedPage.type) {
      case PageType.Page:
        return (
          <div className="brochure-product-page-wrapper">
            <div className={`crop-cont`}>
              {this.renderPage(selectedPage, selectedPage.position === 'right' ? true : false)}
            </div>
          </div>);
      case PageType.Front:
        return (
          <div className={`crop-cont crop-cont--cover`}>
            {this.renderFront()}
          </div>
        );
      case PageType.Back:
        return (
          <div className={`crop-cont crop-cont--cover`}>
            {this.renderBack()}
          </div>
        );
        default:
          return (
            <div></div>
          );
    }
  }

  render() {
    const { editor } = this.props;
    return (this.renderSpread(editor!.selectedSpread!));
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Brochure/BrochureContainer.tsx